//import { motion } from "framer-motion";

import classNames from "classnames";
import classes from "./header.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
function Header({ isOpen, label, onClick, className }) {
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="flex-start"
      className={classNames(classes.header, className, {
        [classes.open]: isOpen,
        [classes.closed]: !isOpen,
      })}
      onClick={onClick}
    >
      <Flex
        align="flex-start"
        direction="row"
        justify="space-between"
        style={{ width: "100%" }}
      >
        <Label tag="p" align="start" size="md" color="secondary">
          {label}
        </Label>
        <img
          src={
            isOpen
              ? "/images/icons/icon-meno.svg"
              : "/images/icons/icon-piu.svg"
          }
          alt="close"
        />
      </Flex>
      {false && <div className={classes.line} />}
    </Flex>
  );
}

export default Header;
